export class LoadFiltersAction {
    public static readonly type = '[JobsPlacements] Load filters';
}
